const TmpPE003 = (page) => {
  const media = [];
  const eMentors = [];
  const updatedVideos = [];
  page.content.core.forEach((difficulty, index) => {
    let transcript = '';

    difficulty.segments.forEach((segment, sIndex) => {
      if (sIndex === 0) {
        transcript += segment.text_tl;
      } else {
        transcript += ' ' + segment.text_tl;
      }
    });

    // build out the media object from the page data
    let mediaObject = {
      id: page.id,
      page: page.id,
      author: 'Team ACV/AAC',
      author_desc_en: 'Team ACV/AAC',
      author_desc_tl: 'N/A',
      cc_license: 'N/A',
      description: page.content.description || 'MISSING DESCRIPTION',
      downloaded_date: new Date().toISOString(),
      published_date: new Date().toISOString(),
      media_url:
        'https://base-media-repo.web.app/' +
        page.label.slice(0, 2).toUpperCase() +
        '/video/' +
        page.label.toLowerCase().replaceAll('-', '_') +
        '_' +
        page.content.core[index].difficulty +
        '.mp4',
      source_url: 'Team ACV/AAC',
      src:
        page.label.toLowerCase().replaceAll('-', '_') +
        '_' +
        page.content.core[index].difficulty +
        '.mp4',
      title_en: 'N/A',
      title_tl: 'N/A',
      transcript: transcript,
      type: 'video'
    };

    if (difficulty.difficulty === 'single') {
      mediaObject.src = page.label.toLowerCase().replaceAll('-', '_') + '.mp4';
    }

    // add the media object to the media array
    media.push(mediaObject);

    const ccData = [];
    difficulty.segments.forEach((segment) => {
      const cc = {
        id: segment.id,
        description: segment.description,
        tl_text: segment.text_tl,
        start_minute: segment.start_minute,
        start_second: segment.start_second,
        end_minute: segment.end_minute,
        end_second: segment.end_second,
      };
      ccData.push(cc);
    });

    updatedVideos.push({
      description: difficulty.description,
      difficulty: index,
      id: difficulty.id,
      media: mediaObject,
      cc: ccData || [],
    });
  });

  const modifiedPage = {
    ...page,
    content: {
      core: updatedVideos || [],
      eMentor: page.content.eMentor || []
    }
  };

  // update the the ementor content with the page id
  if (page.content.eMentor) {
    page.content.eMentor.forEach((mentor) => {
      const eMentor = {
        ...mentor,
        page: page.id,
      };
      eMentors.push(eMentor);
    });
  } 

  // Extract metadata separately
  const metadata = {
    media: media || [],
    images: [],
    materials: [],
    eMentor: eMentors,
    focusPoints: []
  };

  return { modifiedPage, metadata };
};

export default TmpPE003;
